// Localiza e carrega o guia de ajuda de cada tela.
// Cada arquivo de src/ajuda/conteudo/<rota>.md é o guia da rota /<rota>.
// A tela inicial ("/") usa o guia do Caixa Diário.

const ROTA_INICIAL = "caixa-diario";

function carregarArquivos() {
  // require.context só existe no webpack; nos testes com Jest ele lança erro.
  // (Não use "typeof require.context": o webpack reescreve essa expressão.)
  let contexto;
  try {
    contexto = require.context("./conteudo", false, /\.md$/);
  } catch (erro) {
    return {};
  }

  return contexto.keys().reduce((arquivos, chave) => {
    const nome = chave.replace(/^\.\//, "").replace(/\.md$/, "");
    arquivos[nome] = contexto(chave);
    return arquivos;
  }, {});
}

const arquivos = carregarArquivos();
const cacheTextos = new Map();

export function nomeDoGuia(pathname) {
  const nome = String(pathname || "")
    .replace(/^\/+|\/+$/g, "")
    .split("/")[0];

  return nome === "" ? ROTA_INICIAL : nome;
}

export function existeGuia(pathname) {
  return Boolean(arquivos[nomeDoGuia(pathname)]);
}

export async function carregarGuia(pathname) {
  const nome = nomeDoGuia(pathname);
  const url = arquivos[nome];

  if (!url) {
    return null;
  }
  if (cacheTextos.has(nome)) {
    return cacheTextos.get(nome);
  }

  const resposta = await fetch(url);
  if (!resposta.ok) {
    throw new Error(`Não foi possível carregar o guia (${resposta.status}).`);
  }

  const texto = await resposta.text();
  cacheTextos.set(nome, texto);
  return texto;
}
